module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTc2OCA2NGExNjAgMTYwIDAgMSAxLTExNSAyNzEuMmwtMjQyLjYgMTM0LjdhMTYwLjIgMTYwLjIgMCAwIDEtMSA4Ny43bDIzNS41IDE0MC4xYTE2MCAxNjAgMCAxIDEtMzAuMyA1Ni41TDM3OS4yIDYxNC4xYTE2MCAxNjAgMCAxIDEgMi4zLTIwMS4zbDIzNy0xMzEuNkExNjAgMTYwIDAgMCAxIDc2OCA2NHoiIGZpbGw9IiMwIiBwLWlkPSI0NDkyIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Share-filled.svg
// module id = ZmFy
// module chunks = 75